import LkNalogStep1 from './lknalog_1.png';
import LkNalogStep2 from './lknalog_2.png';
import LkNalogStep3 from './lknalog_3.png';
import LkNalogStep4 from './lknalog_4.png';
import EpnStep1 from './epn_1.jpeg';
import EpnStep2 from './epn_2.jpeg';
import EpnStep3 from './epn_3.jpeg';
import EpnStep4 from './epn_4.jpeg';

export {
    LkNalogStep1,
    LkNalogStep2,
    LkNalogStep3,
    LkNalogStep4,
    EpnStep1,
    EpnStep2,
    EpnStep3,
    EpnStep4,
};
